"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Main } from "@/components/ui/Main";
import { MotionLink } from "@/components/ui/Motion";
import { TypographyH2, TypographyP } from "@/components/ui/typography";
import { cls } from "../lib/utils";

function NotFound() {
  return (
    <Main
      className={cls`h-screen w-screen flex flex-col justify-center items-center`}
    >
      <TypographyH2>Oops! Page Not Found</TypographyH2>
      <TypographyP>The page you are looking for is missing!</TypographyP>

      <Button className={cls`mt-10`} asChild>
        <MotionLink href={"/"}>Let&apos;s Get You Back Home</MotionLink>
      </Button>
    </Main>
  );
}

export default NotFound;
